import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import './footer.scss';
import { Loader } from '../utils/loader/Loader';

type props = {}

export const Footer = (props: any) => {

    const [isOnline, setIsOnline] = useState(false);

    useLayoutEffect(() =>

        setIsOnline(true), [setIsOnline]
    );

    if (isOnline === false) {

        return <Loader />;
    }
    else
        return <footer className="footer">
            <div className="footer_top">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-4 col-md-6 col-lg-4">
                            <div className="footer_widget">
                                <div className="footer_logo">
                                    <a href="/#">
                                        <img src="img/footer_logo.png" alt="" />
                                    </a>
                                </div>
                                <p>INFRONT ITALIA</p>
                                <p>
                                    <div className="infront-logo">
                                        <a rel="noopener noreferrer" href="https://www.infrontfinance.com/" target="_blank"></a>
                                    </div>
                                </p>
                                {/* <div className="socail_links">
                                    <ul>
                                        <li>
                                            <a href="/#">
                                                <i className="ti-facebook"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="/#">
                                                <i className="ti-twitter-alt"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="/#">
                                                <i className="fa fa-instagram"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div> */}

                            </div>
                        </div>
                        <div className="col-xl-2 offset-xl-1 col-md-6 col-lg-3">
                            <div className="footer_widget">
                                <h3 className="footer_title">
                                    Servizi
                            </h3>
                                <ul className="submenu">

                                    {/* service market connect */}
                                    {/* <li><Link onClick={(event) => {
                                        
                                        props.clickhandler("marketconnect")
                                    }
                                    }
                                        to={'/Service'}  style={{ cursor: 'pointer' }}> MARKET CONNECT </Link></li> */}
                                    {/* end */}

                                    {/* servie web */}
                                    <li><Link onClick={() => {

                                        props.clickhandler("Market Connect Web")
                                    }
                                    }
                                        to={'/Service'} > MARKET CONNECT WEB </Link></li>
                                    {/* end */}

                                    {/* servie client */}
                                    <li><Link onClick={() => {

                                        props.clickhandler("Market Connect Client")
                                    }
                                    }
                                        to={'/Service'} > MARKET CONNECT CLIENT </Link></li>
                                    {/* end */}

                                    {/* services mifid */}
                                    {/* <li><Link onClick={() => {

                                        props.clickhandler("mifid")
                                    }
                                    }
                                        to={'/ServiceServices'} > MIFID </Link></li> */}
                                    {/* end */}

                                    {/* services feed */}
                                    <li><Link onClick={() => {

                                        props.clickhandler("Market Connect Feed")
                                    }
                                    }
                                        to={'/ServiceServices'} > MARKET CONNECT FEED </Link></li>
                                    {/* end */}

                                    {/* services finsite */}
                                    <li><Link onClick={() => {

                                        props.clickhandler("Finsite")
                                    }
                                    }
                                        to={'/ServiceServices'} > FINSITE </Link></li>
                                    {/* end */}

                                    {/* services investorrelations */}
                                    <li><Link onClick={() => {

                                        props.clickhandler("Investor Relations")
                                    }
                                    }
                                        to={'/Service'} > INVESTOR RELATIONS </Link></li>
                                    {/* end */}

                                    {/* services web services */}
                                    <li><Link onClick={() => {

                                        props.clickhandler("Web Services")
                                    }
                                    }
                                        to={'/Service'} > WEB SERVICES </Link></li>
                                    {/* end */}

                                </ul>

                            </div>
                        </div>
                        <div className="col-xl-2 col-md-6 col-lg-2">
                            <div className="footer_widget">
                                <h3 className="footer_title">
                                    Links Utili
                            </h3>
                                <ul>
                                    <li><Link onClick={() => {props.clickhandler("home")}} to={'/Home'} > HOME </Link></li>
                                    <li><Link onClick={() => {

                                        props.clickhandler("about")
                                    }
                                    } to={'/About'} > CHI SIAMO </Link></li>
                                    <li><Link onClick={() => {

                                        props.clickhandler("contacts")
                                        
                                    }
                                    } to={'/Contacts'} > CONTATTI </Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6 col-lg-3">
                            <div className="footer_widget">
                                <h3 className="footer_title">
                                    Sede - Contatti
                            </h3>
                                <ul>
                                    <li>Milano, Italia</li>
                                    <li>Corso di Porta Romana 68 - 20122</li>
                                    <li><a href={`tel:+39 02 94755082`}>+39 02 87330815</a></li>
                                    <li>Da Lunedì a Venerdì <br/>dalle ore 8:00 alle ore 20:00</li>
                                    <li><a href={`mailto:customerservice@infrontfinance.com`}>customerservice@infrontfinance.com</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="copy-right_text">
                <div className="container">
                    <div className="footer_border"></div>
                    <div className="row">
                        <div className="col-xl-12">
                            <p className="copy_right text-center copyright-label">
Copyright &copy;<script>document.write(new Date().getFullYear());</script> All rights reserved | This template is made with <i className="fa fa-heart-o" aria-hidden="true"></i> by <a href="https://colorlib.com" target="_blank">Colorlib</a>
                        </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
}